import { Box } from '@cp/ds/src/components/box';
import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { RouteConfigComponentProps } from 'react-router-config';
import { usePathGenerator } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { RoutedLink as Link, RoutedLink } from 'src/shared/ui/link';
import Header from 'src/widgets/header';
import { usePageMetaTags } from '../../shared/hooks/useMetaTags';
import { PageMetaTags } from '../../shared/components/layout/components/meta';

const LegalInformation: React.FC<RouteConfigComponentProps> = () => {
  const generateAppPath = usePathGenerator();
  const renderConfig = usePageMetaTags();

  return (
    <Box>
      <PageMetaTags renderConfig={renderConfig} />

      <Header />

      <Container sx={{ pb: { xs: 6, md: 20 } }}>
        <Breadcrumbs
          LinkComponent={RoutedLink}
          items={[
            {
              path: '/',
              label: 'Главная',
            },
            {
              path: '',
              label: 'Правовая информация',
            },
          ]}
          sx={{ my: 2 }}
        />
        <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, m: 0, mb: 2.75 }}>
          Правовая информация
        </Typography>
        <Typography sx={{ my: 2 }}>
          Использование сайта YouHelp.ru незарегистрированным пользователем и регистрация на YouHelp.ru подразумевает полное согласие с
          нашей <Link href={generateAppPath({ page: ClientWebPage.PrivacyPolicy })}>политикой конфиденциальности</Link>, а также с{' '}
          <Link href={generateAppPath({ page: ClientWebPage.UserAgreement })}>правилами использования сайта.</Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default LegalInformation;
